import React from 'react';

const Loading: React.FC = () => {
  return (
    <h3 id='loading-icon'>Loading...</h3>
  );
};

export default Loading;